import { add, multiply } from './math';

interface LiquidationProceeds {
  remainingBalanceOwed: number;
  totalPaid: number;
}

// A negative `remainingBalanceOwed` means the liquidation proceeds exceeded everything owed; the
// overage is parked in suspense. The gross transaction amount is the proceeds applied to balances
// (`totalPaid`) plus that suspense overage. Shared so the recorded transaction
// (`liquidationToTransactionInput`) and the activity-feed UI can't drift.
export const getLiquidationSuspenseAndAmount = ({ remainingBalanceOwed, totalPaid }: LiquidationProceeds) => {
  const suspense = remainingBalanceOwed < 0 ? multiply(remainingBalanceOwed, -1) : 0;
  return { suspense, amount: add(totalPaid, suspense) };
};
